<template>
  <div>
    <div class="tabs h-80">
      <div
        class="tab"
        v-for="item in options"
        :key="item.key"
        :class="{ active: item.key === curTab }"
        @click="() => handleTabClick(item.key)"
      >
        <div class="tab-text">{{ item.text }}</div>
      </div>
    </div>
    <div class="h-80" />
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    curTab: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  methods: {
    handleTabClick(key) {
      this.$emit('tabClick', key);
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  width: 100vw;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  z-index: 999;
  background-color: #ffffff;
  box-sizing: border-box;
  box-shadow: inset 0px -1px 0px 0px rgba(230, 230, 230, 1);

  .tab {
    flex: 1;
    font-size: 28px;
    color: #646464;
    letter-spacing: -1.29px;
    text-align: center;
    font-weight: 400;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .tab-text {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
    &.active {
      font-size: 28px;
      color: #fc681d;
      letter-spacing: -1.29px;
      text-align: center;
      font-weight: bold;

      .tab-text::after {
        content: "";
        width: calc(100% + 24px);
        height: 6px;
        background: #fc681d;
        border-radius: 4px;
        position: absolute;
        left: 50%;
        bottom: 0px;
        transform: translateX(-50%);
      }
    }
  }
}
.h-80 {
  height: 80px;
}
</style>
